import logo from './logo.svg';
import './App.css';
import Nav from './components/Nav';

import Portfolio from './components/Portfolio';


function App() {
  return (
    <div className="App">
     
      <Nav />
    </div>
  );
}

export default App;
